import initiativeRegistry from '@/app/modules/MeasuresTtrStd/store/initiativeRegistry';

export default {
  initiativeRegistry,
};
